import { CoApplicantPipe } from '@hb/modules/global';
import { OwnMoneyPartStoreService } from '@hb/modules/extra-asset/own-money-part/own-money-part-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'own-money-amount',
    templateUrl: './own-money-amount.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, ApAmountInputComponent, AdditionalInfoComponent, NextButtonComponent, CoApplicantPipe],
    providers: [
        { provide: GLOBAL_STORE, useExisting: OwnMoneyPartStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.OWN_MONEY_AMOUNT }
    ]
})
export class OwnMoneyGlobalComponent extends GlobalInjectComponent<OwnMoneyPartStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(OwnMoneyPartStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getOwnMoneyAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setOwnMoneyAmount(amount));
    }
}
